// src/components/UI/TutorialSampleCards.js
import React from 'react';
import styles from './TutorialSampleCards.module.css';

const formatPrice = (symbol, value) => {
  if (value == null) return '';
  return `${symbol}${Number(value).toLocaleString('en-IN')}`;
};

const TutorialSampleCards = ({ samples, onSelect }) => (
  <div className={styles.row}>
    {samples.map((s) => {
      const { asin, title, main_image, rating, ratings_total, price, list_price, currency_symbol, promo_label } = s;
      return (
        <button
          key={asin}
          type="button"
          className={styles.card}
          onClick={() => onSelect(asin)}
        >
          <div className={styles.imageBox}>
            {main_image ? (
              <img src={main_image} alt="" className={styles.image} loading="lazy" />
            ) : null}
          </div>
          <div className={styles.title} title={title}>{title}</div>
          {(rating || ratings_total) && (
            <div className={styles.rating}>
              <span className={styles.stars}>{rating ? `★ ${rating}` : ''}</span>
              {ratings_total ? <span className={styles.count}>({Number(ratings_total).toLocaleString('en-IN')})</span> : null}
            </div>
          )}
          {promo_label ? <div className={styles.promo}>{promo_label}</div> : null}
          <div className={styles.priceRow}>
            <span className={styles.price}>{formatPrice(currency_symbol || '₹', price)}</span>
            {list_price && list_price > price ? (
              <span className={styles.listPrice}>{formatPrice(currency_symbol || '₹', list_price)}</span>
            ) : null}
          </div>
        </button>
      );
    })}
  </div>
);

export default TutorialSampleCards;
